import { LogClient } from "@mnemonic/logging";

import type { TStoredAuth } from "./authStateTypes";

//
// Similar functions here are also defined in the User repo
// ⚠️ When making changes here, make sure to for test compatability with User! ⚠️
//
// (Yes, we should have a better solution than copy-pasting)
// (No, nobody can/will justify spending time on a better solution)
//

/* ==================================================================================
 * STORAGE I/O – Storage helpers for authStateUtils.ts
 * ================================================================================== */
const STORAGE_KEY = "authorization";

const write = <T>(data: TStoredAuth<T> | null): TStoredAuth<T> | null => {
  if (!data) {
    sessionStorage.removeItem(STORAGE_KEY);
    return null;
  }
  try {
    const str = JSON.stringify(data);
    sessionStorage.setItem(STORAGE_KEY, str);
    return data;
  } catch (error) {
    LogClient.getInstance().logError("Failed to serialize stored auth", error);
    return null;
  }
};

// Note: This function isn't identical to the one in User
// In User, read() only returns the state if it has a token
const read = <T>(): TStoredAuth<T> | null => {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as TStoredAuth<T>;
    return parsed;
  } catch (error) {
    LogClient.getInstance().logError("Failed to deserialize stored auth", error);
    return null;
  }
};

/**
 * These utils are only intended as helpers for authStateUtils.ts.
 *
 * Use or extend authStateUtils instead, and use those where needed.
 *
 * DO NOT USE THESE UTILS TO;
 * - Manage the user's auth state (outside of the dedicated authStateUtils.ts)
 *
 * DO use these utils to;
 * - Reading/writing sessionStorage as part of a function in authStateUtils.ts
 */

export const DO_NOT_USE_OUTSIDE_OF_authStateUtils = {
  write,
  read,
} as const;
